<h2 mat-dialog-title>Add Client Scope</h2>
<mat-dialog-content>
    <form [formGroup]="scopeForm" (ngSubmit)="submit()">
        <mat-form-field>
            <mat-label>Reference Code</mat-label>
            <input matInput formControlName="reference_code">
        </mat-form-field>
                <mat-form-field>
            <mat-label>Reference Scope</mat-label>
            <input matInput formControlName="reference_scope">
        </mat-form-field>
        <mat-form-field>
            <mat-label>SCAC</mat-label>
            <input matInput formControlName="contact_scac">
        </mat-form-field>
        <app-contact-autocomplete
            placeholder="Search contacts..." 
            [type]="'customer_contact_list'" 
            [formControl]="contactControl" 
            (selected)="onContactSelected($event)"
        ></app-contact-autocomplete>
    </form>
</mat-dialog-content>
<mat-action-list>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-raised-button (click)="submit()" color="primary">Submit</button>
</mat-action-list>